"use client";

import { cn } from "@deputy-ai/common";
import { Button, type ButtonProps } from "@deputy-ai/ui/button/Button";
import type { ComponentProps } from "react";
import { FiChevronsDown } from "react-icons/fi";
import type { OverrideProperties } from "type-fest";

export type UiBackToBottomProps = OverrideProperties<
  ComponentProps<"div">,
  {
    onClick: ButtonProps["onClick"];
  }
> & {
  count: number;
};

export function UiBackToBottom({
  count,
  onClick,
  className,
}: UiBackToBottomProps) {
  const text = count > 0 ? `${count} new message${count > 1 ? "s" : ""}` : null;

  return (
    <div
      className={cn(
        "absolute left-1/2 z-10 -translate-x-1/2 rounded-full shadow-md",
        className
      )}
    >
      <Button
        className="rounded-full bg-white"
        onClick={onClick}
        size="xs"
        variant="ghost"
        icon={<FiChevronsDown />}
      >
        {text}
      </Button>
    </div>
  );
}
